<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const query = ref('')

function onEnterKey(event) {
  // if (!query.value.trim()) return
  router.push({ name: 'search', query: { q: query.value.trim() } })
  event.target.blur() // remove focus from this input after pressing enter
}

function onFocus(event) {
  event.target.select() // select all text on focus
}

function clearSearch() {
  query.value = ''
}
</script>

<template lang="pug">
InputGroup.round-border
  InputGroupAddon: i.ph.ph-magnifying-glass
  InputText#topNavSearchInput(v-model="query" placeholder="Search  ⌘+K" @keyup.enter="onEnterKey" @focus="onFocus")
  InputGroupAddon: Button(icon="ph ph-x" text severity="secondary" @click="clearSearch")
</template>

<style lang="scss">

// input:focus {
//   background-color: var(--color-canvas-50);
// }
</style>